/* eslint-disable jsx-a11y/click-events-have-key-events */

import ClickOutside from 'Component/ClickOutside';
import SearchCloseIcon from 'Component/SearchCloseIcon';
import SearchIcon from 'Component/SearchIcon';
import {
    SearchFieldComponent as SourceSearchFieldComponent,
} from 'SourceComponent/SearchField/SearchField.component';
import {ReactElement} from 'Type/Common.type';

import './SearchField.override.style';

/** @namespace Steinkrueger/Component/SearchField/Component */
export class SearchFieldComponent extends SourceSearchFieldComponent {
    renderSearchIcon(): ReactElement {
        const { isActive } = this.props;

        return (
            <>
                { isActive && (
                    <div
                      block="SearchField"
                      elem="CloseIcon"
                      role="button"
                      tabIndex={ 0 }
                      onClick={ this.closeSearch }
                      aria-label={ __('Close') }
                    >
                        <SearchCloseIcon />
                    </div>
                ) }
                    <div
                      block="SearchField"
                      elem="SearchIcon"
                      role="button"
                      tabIndex={ 0 }
                      onClick={ this.openSearch }
                      aria-label={ __('Search') }
                    >
                        <SearchIcon />
                    </div>
            </>
        );
    }

    render(): ReactElement {
        const {
            isVisible,
            isActive,
            shouldAvailableDateRender,
        } = this.props;

        return (
            <div block="SearchField" mods={ { isVisible, isActive, availableDateMode: !!shouldAvailableDateRender } }>
                <ClickOutside onClick={ this.closeSearch }>
                    <div block="SearchField" elem="Wrapper">
                        { this.renderSearch() }
                    </div>
                </ClickOutside>
            </div>
        );
    }
}

export default SearchFieldComponent;
